import React from 'react';

import {AutosuggestItem} from '@pb/kit-component-autosuggest-v2';

import type {DictionaryItem} from 'src/openapi/admin/models/DictionaryItem';

type Props = {
    suggestions: DictionaryItem[],
};

export const CountriesList = ({suggestions}: Props) => {
    if (!suggestions.length) {
        return (
            <div className="pd-s">
                No countries found
            </div>
        );
    }

    return (
        <div>
            {suggestions.map(country => (
                <AutosuggestItem
                    key={country.code}
                    value={country}
                    caption={country.description}
                />
            ))}
        </div>
    );
};
